<template>
    <!-- Start Boxes Area -->
    <section class="boxes-area">
        <div class="container">
            <div class="row">
                <div class="col-lg-4 col-md-6 col-sm-6">
                    <div class="single-box">
                        <div class="icon">
                            <feather type="server"></feather>
                        </div>
                        <h3>{{ $t('WE EVALUATE HOW BLOCKCHAIN CAN HELP')}}</h3>
                        <p style="text-align: justify;" >{{ $t('From a decision-making algorithm, we identify the potential that blockchain has in your organization and we design an application proposal.') }}</p>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6 col-sm-6">
                    <div class="single-box bg-f78acb">
                        <div class="icon">
                            <feather type="code"></feather>
                        </div>
                        <h3>{{$t('WE DEVELOP SOLUTIONS FOR YOUR BUSINESS')}}</h3>
                        <p style="text-align: justify; ">{{ $t('We develop software that uses blockchain technology to advance your business objectives and help you create innovative and impactful products.') }}</p>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6 col-sm-6">
                    <div class="single-box bg-c679e3">
                        <div class="icon">
                            <feather type="users"></feather>
                        </div>
                        <h3>{{ $t('WE TRAIN AND EDUCATE ABOUT BLOCKCHAIN') }}</h3>
                        <p style="text-align: justify;">{{ $t('We provide talks and high-impact in-company courses designed to provide your staff with the necessary knowledge for the benefit of your business.') }}</p>
                    </div>
                </div>

                <!-- <div class="col-lg-3 col-md-6 col-sm-6">
                    <div class="single-box bg-eb6b3d">
                        <div class="icon">
                            <feather type="git-branch"></feather>
                        </div>
                        <h3>Access Controlled</h3>
                        <p>Lorem ipsum dolor sit amet elit, adipiscing, sed do eiusmod tempor incididunt ut labore dolore magna.</p>
                    </div>
                </div> -->
            </div>
        </div>
    </section>
    <!-- End Boxes Area -->
</template>

<script>
export default {
    name: 'BoxesArea'
}
</script>
